<template>
  <div class="section-abstract-header">Documents</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementDocumentListExtend', 'etablissement', true)">
      <v-col>
        <div v-if="etablissement.documentCount <= 0" class="section-abstract-title">Ajouter un document</div>
        <div v-else class="section-abstract-title">Vous avez {{ etablissement.documentCount }} document(s) enregistré(s)</div>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementDocumentAbstract from '@/generated/sections/SectionEtablissementDocumentAbstract.vue';
  export default defineComponent({
    extends: SectionEtablissementDocumentAbstract,
    components: {},
    methods: {
      headerTitle(): string {
        return "Document(s) pour " + this.etablissement.alias;
      },
    }
  })
</script>
